

































import { Component, Vue } from "vue-property-decorator";
import cCard from "@/components/default/Card.vue";
import cDatagrid from "@/components/default/Datagrid.vue";
import cPopup from "@/components/default/Popup.vue";
import { DxSelectBox } from "devextreme-vue/select-box";
import { DxLookup } from "devextreme-vue";
import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxGroupItem,
  DxItem,
  DxLabel,
} from "devextreme-vue/form";

import {
  DxDataGrid,
  DxEditing,
  DxStateStoring,
  DxColumn,
} from "devextreme-vue/data-grid";
import {
  MeasuringUnit,
  MeasuringUnitsClient,
  CreateMeasuringUnitCommand,
  UpdateMeasuringUnitCommand,
} from "@/data/web-api-client";

import MeasuringUnitTranslationsDialog from '@/modules/articles/components/MeasuringUnitTranslationsDialog.vue';

@Component({
  components: {
    DxDataGrid,
    DxEditing,
    DxStateStoring,
    cCard,
    cDatagrid,
    cPopup,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxItem,
    DxLabel,
    DxColumn,
    DxSelectBox,
    DxLookup,
    MeasuringUnitTranslationsDialog
  },
})
export default class MeasuringUnitsTable extends Vue {
  measuringUnits: MeasuringUnit[] = [];

  private measuringUnitsClient = new MeasuringUnitsClient(undefined, this.$axios);

  async mounted() {
    this.getMeasuringUnits();
  }

  private async getMeasuringUnits() {
    this.measuringUnits = await this.measuringUnitsClient.getMeasuringUnits();
  }

  addRow() {
    const table: any = this.$refs.grid;

    table.instance.addRow();
  }

  initRow(e: any) {
    e.data.name = '';
  }

  async createRow(e: any) {
    const measuringUnit = e.data as MeasuringUnit;

    await this.measuringUnitsClient.create(new CreateMeasuringUnitCommand({
      name: measuringUnit.name
    }));

    this.gridInstance.cancelEditData();
    this.getMeasuringUnits();
  }

  async updateRow(e: any) {
    const measuringUnit: MeasuringUnit = Object.assign(
      {},
      e.oldData as MeasuringUnit,
      e.newData
    );

    await this.measuringUnitsClient.update(new UpdateMeasuringUnitCommand({
      id: measuringUnit.id,
      name: measuringUnit.name
    }));

    this.gridInstance.cancelEditData();
    this.getMeasuringUnits();
  }

  async deleteRow(e: any) {
    await this.measuringUnitsClient.delete(e.data.id);

    this.getMeasuringUnits();
    e.cancel = true;
  }

  openTranslations(e: any) {
    const dialog = this.$refs.measuringUnitTranslationsDialog as any;

    dialog.name = e.data.name;

    dialog.show();
  }

  get columns() {
    return [
      {
        dataField: "name",
        caption: "Naam",
      }
    ];
  }

  get gridInstance() {
    return (this.$refs.grid as any).instance;
  }
}
